export default __webpack_public_path__ + "static/media/Mayank Jain - 6553 - MAYANK JAIN.7ceb0803.jpeg";